import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SiteMessage from '../entities/siteMessage'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface SiteMessageState extends ListState<SiteMessage> {
    editSiteMessage: SiteMessage;
}
class SiteMessageModule extends ListModule<SiteMessageState, any, SiteMessage>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SiteMessage>(),
        loading: false,
        editSiteMessage: new SiteMessage(),
    }
    actions = {
        async getAll(context: ActionContext<SiteMessageState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/SiteMessage/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<SiteMessage>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<SiteMessageState, any>, payload: any) {
            await Ajax.post('/api/services/app/SiteMessage/Create', payload.data);
        },
        async update(context: ActionContext<SiteMessageState, any>, payload: any) {
            await Ajax.put('/api/services/app/SiteMessage/Update', payload.data);
        },
        async delete(context: ActionContext<SiteMessageState, any>, payload: any) {
            await Ajax.delete('/api/services/app/SiteMessage/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<SiteMessageState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/SiteMessage/Get?Id=' + payload.data.id);
            context.state.editSiteMessage = reponse.data.result as SiteMessage;
        },
        async getNotReadCount() {
            let reponse = await Ajax.get('/api/services/app/SiteMessage/GetNotReadMessageCount');
            return reponse.data.result;
        },
        async getWebSiteStatistics() {
            let reponse = await Ajax.get('/api/services/app/Session/GetWebSiteStatistics');
            return reponse.data.result;
        },
        async replayMessage(context: ActionContext<SiteMessageState, any>, payload: any) {
            await Ajax.post('/api/services/app/SiteMessage/ReplayMessage', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: SiteMessageState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SiteMessageState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: SiteMessageState, siteMessage: SiteMessage) {
            state.editSiteMessage = siteMessage;
        }
    }
}
const siteMessageModule = new SiteMessageModule();
export default siteMessageModule;